import http from "./http";

function getCartSession() {
  let key = localStorage.getItem("cart_session");
  if (!key) {
    key = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    localStorage.setItem("cart_session", key);
  }
  return key;
}

const cartHeaders = () => ({
  headers: {
    "X-Cart-Session": getCartSession(),
  },
});

export const cartGet = (storeId) =>
  http.get(`/orders/cart/${storeId}/`, cartHeaders());

export const cartAdd = (storeId, payload) =>
  http.post(`/orders/cart/${storeId}/`, payload, cartHeaders());

/* ✅ حذف آیتم */
export const cartRemove = (storeId, productId, colorId = null) =>
  http.post(
    `/orders/cart/${storeId}/`,
    {
      product_id: productId,
      color_id: colorId,
      quantity: 0,
    },
    cartHeaders(),
  );

export const checkout = (storeId, payload) =>
  http.post(`/orders/checkout/${storeId}/`, payload, cartHeaders());
